// websocket.service.ts
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class WebsocketService {
  private socket: WebSocket | null = null;
  public messages: Subject<any> = new Subject<any>();

  private robotKey: string = "";
  private robotSerie: string = "";

  constructor() {
    this.connect();
    this.robotKey = localStorage.getItem("robotKey") ?? "";
    this.robotSerie = localStorage.getItem("robotSerie") ?? "";
  }

  connection_timeout: any = null;
  alive_message_interval: any = null;
  private connect(): void {
    if (this.connection_timeout != null) clearTimeout(this.connection_timeout);
    if (this.alive_message_interval != null) clearInterval(this.alive_message_interval);
    // Reemplaza la URL con la dirección de tu servidor WebSocket
    this.socket = new WebSocket(
      `wss://desarrollo4.i4life.es/pam/${environment.production ? "prod" : "dev"}/?serie=${this.robotSerie}&key=${this.robotKey}&app=true`,
    );

    this.socket.onopen = (event) => {
      console.log("[WebSocket] Conexión abierta");
      //Stops loading animations if exists... (for example)
    };

    this.socket.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data);
        this.messages.next(message);
      } catch (err) {
        console.error(err);
      }
    };

    this.socket.onclose = (event) => {
      console.log("[WebSocket] Conexión cerrada");

      this.connection_timeout = setTimeout(() => {
        this.connect();
      }, 1000);
    };
  }

  public send(message: any): void {
    this.socket?.send(JSON.stringify(message));
  }

  public close(): void {
    this.socket?.close();
  }
}
